import { mergeClassNames } from '@/utils/mergeClassNames';

import { CalibrationStatusArray } from '@/hooks/useSensor';

import styles from './SensorCard.module.css';

interface SensorCardCalibratingProps {
  /** Calibration status indicators, should be an array of exactly 15 statuses */
  calibrationStatus?: CalibrationStatusArray;
}

export const SensorCardCalibrating = ({ calibrationStatus }: SensorCardCalibratingProps) => {
  return (
    <div className={styles.calibrationIndicators}>
      {calibrationStatus?.map((status, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={mergeClassNames(styles.calibrationIndicator, styles[status])} key={idx}></div>
      ))}
    </div>
  );
};
